<template>
    <div>
        <div v-if="options_loaded && passed_filter">
            <div class="designeroption" :data-designer-component-id="component_id">
                <h3>
                    Select Any Necessary Add Ons
                    <designer-question-popup-info
                        v-if="has_popup_info"
                        :popup_info_title_html="popup_info_title_html"
                        :popup_info_inner_html="popup_info_inner_html"
                    ></designer-question-popup-info>
                </h3>
                <div class="stylesoption">
                    <div class="addonoption">
                        <table>
                            <tbody>
                            <tr>
                                <td width="25%">&nbsp;</td>
                                <td width="25%">Left</td>
                                <td width="25%">Top</td>
                                <td width="25%">Right</td>
                            </tr>
                            <tr v-for="option in filtered_option_list">
                                <td>{{ option.label }}</td>
                                <td>
                                    <span>
                                        <select class="form-control addons" v-model="localTarget.left[option.value]">
                                            <option v-for="i in 3" :value="i-1">{{ i-1 }}</option>
                                        </select>
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        <select class="form-control addons" v-model="localTarget.top[option.value]">
                                            <option v-for="i in 3" :value="i-1">{{ i-1 }}</option>
                                        </select>
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        <select class="form-control addons" v-model="localTarget.right[option.value]">
                                            <option v-for="i in 3" :value="i-1">{{ i-1 }}</option>
                                        </select>
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import Question from "../mixin/Question.vue";

export default {
    mixins: [
        Question
    ],
    props: {
        title: {
            default() {
                return 'Technical Addon';
            }
        },
        component_id: {
            default() {
                return 'addons';
            }
        },
        frameProfile: {
            required: true
        },
        frameCombination: {
            default() {
                return '';
            }
        },
        doorRange: {
            default() {
                return '';
            }
        }
    },
    mounted() {
        for (var propertyName in this.localTarget) {
            if (Array.isArray(this.localTarget[propertyName])) {
                this.localTarget[propertyName] = {};
            }
        }
    },
    computed: {
        filtered_option_list() {
            if (Array.isArray(this.option_list)) {
                return this.option_list.filter((key) => {
                    return key.value !== null;
                });
            } else {
                return [];
            }
        },
        passed_filter() {
            return this.variable_ready(this.frameProfile);
        },
        url() {
            return '/api/options/' + this.fabricator + '/technical-addon?profile=' + this.frameProfile + '&frame_combination=' + this.frameCombination + '&door_range=' + this.doorRange;
        },
        cache_key() {
            return '_' + this.frameProfile + '_' + this.frameCombination + '_' + this.doorRange;
        }
    },
    methods: {
        select_first() {
            // Comment because Mike
        }
    },
    watch: {
        'frameProfile': function (val, oldVal) {
            this.update_options();
        },
        'frameCombination': function (val, oldVal) {
            this.update_options();
        },
        'doorRange': function (val, oldVal) {
            this.update_options();
        },
        'filtered_option_list': function (new_val) {
            if (new_val.length > 0) {

                let options_to_check = [
                    this.localTarget.left,
                    this.localTarget.right,
                    this.localTarget.top,
                ];

                options_to_check.forEach((val) => {
                    for (var propertyName in val) {
                        if (new_val.find((el) => {
                            return parseInt(el.value) === parseInt(propertyName);
                        }) === undefined) {
                            delete val[propertyName];
                        }
                    }
                });
            }
        }
    }
}
</script>
